import {Injector, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'workflow'
})
export class WorkflowPipe implements PipeTransform {

  constructor(private injector: Injector) {}

  transform(value: any, args?: any): any {

    const _translate = this.injector.get(TranslateService);

    switch (value) {

      case 'WF1':
        return  `${value} (${_translate.instant('workflow.WF1')})`;
      case 'WF1ST1':
        return  `${value} (${_translate.instant('workflow.WF1ST1')})`;
      case 'WF2':
        return  `${value} (${_translate.instant('workflow.WF2')})`;
      case 'WF2ST1':
        return  `${value} (${_translate.instant('workflow.WF2ST1')})`;
      case 'WF2ST2':
        return  `${value} (${_translate.instant('workflow.WF2ST2')})`;
      case 'WF2ST3':
        return  `${value} (${_translate.instant('workflow.WF2ST3')})`;
      case 'WF2ST4':
        return  `${value} (${_translate.instant('workflow.WF2ST4')})`;
      case 'WF2ST6':
        return  `${value} (${_translate.instant('workflow.WF2ST6')})`;
      case 'WF2ST7':
        return  `${value} (${_translate.instant('workflow.WF2ST7')})`;
      case 'WF3':
        return  `${value} (${_translate.instant('workflow.WF3')})`;
      default:
        return  _translate.instant('workflow.DEFAULT');

    }

  }
}
